export const getCubeSrc = (url='') => {
  const splitSrc = url.split('/');

  if (splitSrc.length < 5) return null;

  return `${splitSrc[0]}/${splitSrc[1]}/${splitSrc[2]}/${splitSrc[3]}/${splitSrc[4]}/${splitSrc[4]}.tiles/`;
};
